import React, { PropTypes, Component } from "react";
import styled from "styled-components";
import { NitroText } from "nitro-components";

const Container = styled.div`
display:flex;
flex-direction: row;  /* make main axis vertical */
justify-content: center; /* center items vertically, in this case */
align-items: center;
width:100%;
`;

const LabelSection = styled.div`
padding-right:8px;
`;

const StarSection = styled.div`
padding-left:10px;
font-size: ${props => props.starSize};
color: ${props => props.theme.color[props.variant]};
& span {
	padding-left:7px;
	}
`;

const renderIcon = () => {
	return <i style={{ fontStyle: "normal" }}>★</i>;
};

const SafteyRating = props => {
	return (
		<Container>
			<LabelSection>
				<NitroText variant="white" size={14} bold>
					{props.label}
				</NitroText>
			</LabelSection>
			<StarSection starSize={props.starSize} variant={props.variant}>
				{renderIcon()}
				<span>{props.ratingValue}</span>
			</StarSection>
		</Container>
	);
};

SafteyRating.propTypes = {
	label: PropTypes.string,
	ratingValue: PropTypes.string,
	starSize: PropTypes.number,
	variant: PropTypes.string
};

SafteyRating.defaultProps = {
	label: "Saftey",
	starSize: 14,
	variant: "gold"
};

export default SafteyRating;



// WEBPACK FOOTER //
// ./src/features/dashboard/components/SafteyRating.js